/**
 * i18n/index.ts — react-i18next setup với LanguageDetector và workspace namespace.
 *
 * CR-WS-028 | TASK-WS028-001, TASK-UI-WS028-011
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import vi from "./vi.json";
import { workspaceNamespace } from "./workspace";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
        workspace: workspaceNamespace.en,
      },
      vi: {
        translation: vi,
        workspace: workspaceNamespace.vi,
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

// Explicitly register bundles for namespace 'workspace'
i18n.addResourceBundle("vi", "workspace", workspaceNamespace.vi, true, true);
i18n.addResourceBundle("en", "workspace", workspaceNamespace.en, true, true);

export default i18n;
